import _ from 'lodash'
import { createSelector } from 'reselect'
import { selectors as imported } from '../../imports'
import { getProgressText } from '../texts/selectors'

const getLaunchProgresses = state => state.launchProgressBarReducer.progress || {}
const getLaunchProgressesFor = (state, serverId) => {
    const progresses = getLaunchProgresses(state)
    return progresses[serverId] || {}
}

const getActiveLaunchProgresses = createSelector(
    [getLaunchProgresses, imported.getActiveServerId],
    (progresses, serverId) => progresses[serverId] || {},
)

export const getActiveRunningLaunchProgresses = createSelector(
    [getActiveLaunchProgresses],
    progresses =>
        // now I have something like so:
        // { testuser_1: 0, testuser_2: 0.2, testuser_3: 1 }
        // What I want is this
        // [ 'testuser_2', 'testuser_3']
        _.reduce(
            progresses,
            (result, progress, userId) => {
                if (progress > 0) result.push(userId)
                return result
            },
            [],
        ),
)

const getUserLaunchProgress = (state, serverId, userId) => {
    const progresses = getLaunchProgressesFor(state, serverId)
    return progresses[userId] || 0
}

const getUserActiveLaunchProgress = (state, userId) => {
    const progresses = getActiveLaunchProgresses(state)
    return progresses[userId] || 0
}

export const getLaunchProgress = (state, serverId, userId) => {
    const progress = getUserLaunchProgress(state, serverId, userId)
    return {
        percent: progress,
        text: getProgressText(state, progress),
    }
}

export const getActiveLaunchProgress = (state, userId) => {
    const progress = getUserActiveLaunchProgress(state, userId)
    return {
        percent: progress,
        text: getProgressText(state, progress),
    }
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/data/progress/selectors.js